// extracted by mini-css-extract-plugin
export default {"garments":"Home_garments__+eAgH"};